import PropTypes from "prop-types";
import "./FrameComponent.css";
import downarrow from "../../../assets/images/arrowdown-1@2x.png";
import rightdownarrow from "../../../assets/images/arrowdown@2x.png";
import calender from "../../../assets/images/vuesaxlinearcalendar-1.svg";
import UIConfig from "../../constants/UIConfig";

const FrameComponent1 = ({
  className = "",
  date,
  sectionLength,
  setSection,
  currentSection,
  disabled = false,
}) => {

  // ✅ Correct Date Formatter (handles EST string)
  const formatDate = (dateStr) => {
    if (!dateStr) return "MM/DD/YYYY";

    const dateObj = new Date(dateStr);
    if (isNaN(dateObj)) return "MM/DD/YYYY";

    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: UIConfig.branding.timeZone || "America/New_York",
    };

    const parts = new Intl.DateTimeFormat("en-US", options).formatToParts(dateObj);
    const dateMap = {};
    parts.forEach(({ type, value }) => {
      dateMap[type] = value;
    });

    return `${dateMap.month}/${dateMap.day}/${dateMap.year}`;
  };

  const handleNext = () => {
    if (disabled || currentSection >= sectionLength - 1) return;
    setSection((prevSection) => prevSection + 1);
  };

  const handlePrevious = () => {
    if (disabled || currentSection <= 0) return;
    setSection((prevSection) => prevSection - 1);
  };

  return (
    <div className={`calendar-dropdown-parent ${className}`}>
      <div className="calendar-dropdown">
        
        {/* Previous Arrow */}
        <img
          className={`arrow-down-icon ${
            disabled || currentSection === 0 ? "icon-disabled" : ""
          }`}
          loading="lazy"
          alt="Previous"
          src={rightdownarrow}
          onClick={handlePrevious}
          title={disabled ? "Navigation is disabled while a PDF is generating" : undefined}
        />

        {/* Date Display */}
        <div className="march-2024-wrapper">
          <div className="march-2024">
            {formatDate(date)}
          </div>
        </div>

        {/* Calendar Icon */}
        <div className="vuesaxlinearcalendar-wrapper">
          <img className="vuesaxlinearcalendar-icon" alt="calendar" src={calender} />
        </div>

        {/* Next Arrow */}
        <img
          className={`arrow-down-icon ${
            disabled || currentSection === sectionLength - 1 ? "icon-disabled" : ""
          }`}
          loading="lazy"
          alt="Next"
          src={downarrow}
          onClick={handleNext}
          title={disabled ? "Navigation is disabled while a PDF is generating" : undefined}
        />
      </div>

      <div className="meeting-date">Meeting Date</div>
    </div>
  );
};

FrameComponent1.propTypes = {
  className: PropTypes.string,
  date: PropTypes.string,
  sectionLength: PropTypes.number,
  setSection: PropTypes.func,
  currentSection: PropTypes.number,
  disabled: PropTypes.bool,
};

export default FrameComponent1;